/* PLP mobiel: eenmalig een "hupje" als hint dat de kaart naar de tweede foto kan swipen (WOO-685). */
(() => {
  const TRACK = '.card__slides--swipe';
  const swipeMedia = window.matchMedia('(max-width: 899px) and (hover: none)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Wachttijd vanaf het moment dat de kaart in beeld is; het hupje komt pas als beide foto's geladen zijn.
  const NUDGE_DELAY = 3000;

  const imagesLoaded = (track) =>
    Promise.all(
      Array.from(track.querySelectorAll('img')).map((img) =>
        img.complete && img.naturalWidth
          ? Promise.resolve()
          : new Promise((resolve) => {
              img.addEventListener('load', resolve, { once: true });
              img.addEventListener('error', resolve, { once: true });
            })
      )
    );

  // De tweede foto laden zodra de kaart bijna in beeld is. Hij staat buiten beeld in de strook,
  // dus native lazy loading laadt hem pas tijdens het swipen en dan zie je hem nog laden.
  const primeObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              primeObserver.unobserve(entry.target);
              entry.target.querySelectorAll('img[loading="lazy"]').forEach((img) => {
                img.loading = 'eager';
              });
            });
          },
          { rootMargin: '400px 0px' }
        )
      : null;

  const primeTracks = () => {
    if (!primeObserver || !swipeMedia.matches) return;
    document.querySelectorAll(TRACK).forEach((track) => {
      if (track.dataset.primed) return;
      track.dataset.primed = 'true';
      primeObserver.observe(track);
    });
  };

  const nudgeFirstRow = () => {
    if (!swipeMedia.matches || reducedMotion.matches || !('IntersectionObserver' in window)) return;
    const tracks = Array.from(document.querySelectorAll(TRACK)).slice(0, 2);
    if (!tracks.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          const track = entry.target;
          const visibleAt = performance.now();
          imagesLoaded(track).then(() => {
            const wait = Math.max(500, NUDGE_DELAY - (performance.now() - visibleAt));
            window.setTimeout(() => {
              if (track.scrollLeft > 0) return;
              track.classList.add('is-nudging');
              track.addEventListener('animationend', () => track.classList.remove('is-nudging'), { once: true });
            }, wait);
          });
        });
      },
      { threshold: 0.6 }
    );

    tracks.forEach((track) => observer.observe(track));
  };

  const init = () => {
    primeTracks();
    nudgeFirstRow();
    // Filters en sortering vervangen het grid (facets.js); nieuwe kaarten ook vooraf laden
    const grid = document.getElementById('ProductGridContainer');
    if (grid && 'MutationObserver' in window) new MutationObserver(primeTracks).observe(grid, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
